import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { BrandAvatar } from "@faire/retailer-visitor-shared/components/BrandAvatar/index";
import { BrandBagButton } from "@faire/retailer-visitor-shared/components/BrandBagButton/BrandBagButton";
import { ShowroomBadge } from "@faire/retailer-visitor-shared/components/Showroom/ShowroomBadge";
import { Sticky } from "@faire/retailer-visitor-shared/components/Sticky";
import { isLoggedInRetailerOrBrandPreview } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useStickyNavContentPositions } from "@faire/retailer-visitor-shared/navbar/useStickyNavContentPositions";
import { trackBrandClick } from "@faire/retailer-visitor-shared/services/Events";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { usePromoBanners } from "@faire/retailer-visitor-shared/stores/ui/usePromoBanners";
import { useBrandCartHeader } from "@faire/retailer-visitor-shared/views/brand/BrandCart/BrandCartHeader/useBrandCartHeader";
import { generateBrandUrlForProductPage } from "@faire/retailer-visitor-shared/views/product/utils/generateBrandUrlForProductPage";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { formatMoney, moneyOrZero, RoundingStrategy } from "@faire/web--source/common/money";
import { MoneyMath } from "@faire/web--source/common/MoneyMath";
import { faireBaseUrl } from "@faire/web--source/common/routes/faireBaseUrl";
import { Button } from "@faire/web--source/slate/Button";
import { Star } from "@faire/web--source/slate/icons/foundation/Star";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { getSpacing } from "@faire/web--source/slate/spacing/getSpacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { NoTranslate } from "@faire/web--source/ui/lib/localization";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import React from "react";
import styled from "styled-components";
export var ProductStickyBrandHeader = function(param) {
    var product = param.product, brand = param.brand, containerRef = param.containerRef, brandReviewSummary = param.brandReviewSummary, showShowroomBadge = param.showShowroomBadge, numberOfProductsInCart = param.numberOfProductsInCart, setCart = param.setCart, showSidecart = param.showSidecart, cartTotal = param.cartTotal;
    var _brand_profile_image, _brand_profile_image1;
    var onBrandClick = function() {
        if ((brand === null || brand === void 0 ? void 0 : brand.token) !== undefined) {
            trackBrandClick(brand.token, "product_page_simple_brand_title");
        }
    };
    var _usePromoBanners = usePromoBanners(), topOfPageContentHeight = _usePromoBanners.promoBannerHeight;
    var token = brand === null || brand === void 0 ? void 0 : brand.token;
    var _product_token;
    var brandPageUrl = token ? generateBrandUrlForProductPage(token, (_product_token = product === null || product === void 0 ? void 0 : product.token) !== null && _product_token !== void 0 ? _product_token : "") : faireBaseUrl();
    var shouldShowTopShop = brand.is_top_shop && isLoggedInRetailerOrBrandPreview();
    var shouldRetainOriginalPosition = useStickyNavContentPositions(false).shouldRetainOriginalPosition;
    var displayCurrency = useRetailerStore([
        "displayCurrency"
    ]).displayCurrency;
    var brandMinimumAmount = useBrandCartHeader(token !== null && token !== void 0 ? token : "").brandMinimumAmount;
    var belowMinimumAmount = MoneyMath.subtract(brandMinimumAmount, moneyOrZero(cartTotal, displayCurrency));
    return /*#__PURE__*/ _jsx(StyledSticky, {
        top: topOfPageContentHeight,
        containerRef: containerRef,
        $navbar: shouldRetainOriginalPosition,
        children: /*#__PURE__*/ _jsxs(Row, {
            justify: "space-between",
            children: [
                /*#__PURE__*/ _jsxs(Row, {
                    align: "center",
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            onClick: onBrandClick,
                            to: brandPageUrl,
                            children: ((_brand_profile_image = brand.profile_image) === null || _brand_profile_image === void 0 ? void 0 : _brand_profile_image.url) ? /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(BrandAvatar, {
                                        image: brand.profile_image,
                                        size: shouldShowTopShop ? "x-small" : "smaller",
                                        isTopShop: shouldShowTopShop,
                                        iconSize: "22px"
                                    }),
                                    /*#__PURE__*/ _jsx("meta", {
                                        itemProp: "image",
                                        content: (_brand_profile_image1 = brand.profile_image) === null || _brand_profile_image1 === void 0 ? void 0 : _brand_profile_image1.url
                                    })
                                ]
                            }) : null
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            width: "1x"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            style: {
                                textDecoration: "none"
                            },
                            variant: "tertiary",
                            onClick: onBrandClick,
                            linkTo: brandPageUrl,
                            children: /*#__PURE__*/ _jsx(NoTranslate, {
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraphSansMedium",
                                    children: brand.name
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(MaybeBrandReviewSummary, {
                            brandReviewSummary: brandReviewSummary
                        }),
                        /*#__PURE__*/ _jsx(BrandMinimum, {
                            minimumOrderAmount: brandMinimumAmount,
                            total: moneyOrZero(cartTotal, displayCurrency),
                            amountBelowMinimum: belowMinimumAmount
                        }),
                        /*#__PURE__*/ _jsx(MaybeShowroomBadge, {
                            isShowroom: showShowroomBadge
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(BrandBagButton, {
                    totalInCart: numberOfProductsInCart,
                    setCart: setCart,
                    showSidecart: showSidecart
                })
            ]
        })
    });
};
var MaybeBrandReviewSummary = function(param) {
    var brandReviewSummary = param.brandReviewSummary;
    if (!brandReviewSummary) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                width: "1x"
            }),
            /*#__PURE__*/ _jsx(Star, {
                fontSize: "12px",
                fill: Core.icon.default,
                color: Core.icon.default
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: 4
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansRegular",
                children: brandReviewSummary.overallRatingText
            })
        ]
    });
};
export var BrandMinimum = function(param) {
    var minimumOrderAmount = param.minimumOrderAmount, amountBelowMinimum = param.amountBelowMinimum, total = param.total;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var minimumInfo = function() {
        if (MoneyMath.isEqualToZero(minimumOrderAmount)) {
            return strictLocalize({
                id: "k/6A2/",
                defaultMessage: [
                    {
                        type: 1,
                        value: "minimumOrderAmountMoney"
                    },
                    {
                        type: 0,
                        value: " min"
                    }
                ]
            }, {
                minimumOrderAmountMoney: formatMoney({
                    money: minimumOrderAmount,
                    roundingStrategy: RoundingStrategy.DROP_CENTS_ROUND_UP
                })
            });
        } else if (MoneyMath.lessOrEqualToZero(amountBelowMinimum)) {
            return strictLocalize({
                id: "EsJ06y",
                defaultMessage: [
                    {
                        type: 1,
                        value: "minimumOrderMoney"
                    },
                    {
                        type: 0,
                        value: " min reached"
                    }
                ]
            }, {
                minimumOrderMoney: formatMoney({
                    money: minimumOrderAmount,
                    omitCentsIfZero: true
                })
            });
        } else if (!MoneyMath.isEqualToZero(total)) {
            return strictLocalize({
                id: "3TZlrk",
                defaultMessage: [
                    {
                        type: 1,
                        value: "belowMinimumMoney"
                    },
                    {
                        type: 0,
                        value: " to go"
                    }
                ]
            }, {
                belowMinimumMoney: formatMoney({
                    money: amountBelowMinimum,
                    omitCentsIfZero: true
                })
            });
        } else {
            return strictLocalize({
                id: "k/6A2/",
                defaultMessage: [
                    {
                        type: 1,
                        value: "minimumOrderAmountMoney"
                    },
                    {
                        type: 0,
                        value: " min"
                    }
                ]
            }, {
                minimumOrderAmountMoney: formatMoney({
                    money: minimumOrderAmount,
                    roundingStrategy: RoundingStrategy.DROP_CENTS_ROUND_UP
                })
            });
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                width: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansRegular",
                color: Core.text.default,
                children: minimumInfo()
            })
        ]
    });
};
var MaybeShowroomBadge = function(param) {
    var isShowroom = param.isShowroom;
    if (!isShowroom) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                width: "1x"
            }),
            /*#__PURE__*/ _jsx(ShowroomBadge, {
                small: true
            })
        ]
    });
};
var StyledSticky = styled(Sticky).withConfig({
    componentId: "sc-401818c3-0"
})([
    "width:100%;background-color:white;padding:",
    ";z-index:10;"
], getSpacing("2x", "6x"));
